import React, {useState} from 'react'
import styled from 'styled-components';
import Footer from './Footer';
import Navbar from './Navbar';
import img from '../images/JED_rita_habib2.jpg'
import DesktopMenu from './DesktopMenu';
import gif from '../images/spin.gif'




const About = () => {


    const [openSections, setOpenSections] = useState({});

  const toggleSection = (section) => {
    setOpenSections((prevSections) => ({
      ...prevSections,
      [section]: !prevSections[section],
    }));
  };

    return (
        <>
<Navbar/>
<DeskWrap>
<DesktopMenu/>
<Gif src= {gif}/>

<Wrapper>

    <h1>Spectral Center</h1>
    <SpectraDef>
       <h2>spec‧tral /ˈspektrəl/ <em>adjective</em></h2>
    <ol>
        <li><strong>literary</strong> relating to or like a spectre</li>
        <li><strong>technical</strong> relating to or made by a spectrum</li>
    </ol>
    
    <h2>cen‧ter /ˈsentə $ -ər/ <em>noun</em></h2>
    <ol>
        <li><strong>middle</strong> [countable usually singular] the middle of a space, area, or object, especially the exact middle</li>
        <li><strong>building</strong> [countable] a building which is used for a particular purpose or activity</li>
        <li><strong>place of activity</strong> [countable] a place where there is a lot of a particular type of business, activity etc</li>
    </ol>
    
    <h2><em>verb</em> [transitive]</h2>
    <ol><p> move something to a position at the center of something else</p></ol>

    </SpectraDef>

<Body>

<SectionToggle onClick={() => toggleSection('about')}>About Julia E. Dyck</SectionToggle>
<Drop isOpen={openSections.about}>
<Img src= {img}/>

    <p>Julia E. Dyck is a hypnotherapist and artist with roots in Treaty One Territory/Winnipeg, now based between Brussels and Montreal/Tiohtià:ke.</p>
    
    <p>Julia's journey with hypnosis began nearly a decade ago when she sought help to quit smoking. Referred by a bandmate to Andrea Young, Julia skeptically made an appointment that would ultimately transform her life. Through hypnosis, she not only quit smoking but also stopped drinking alcohol, discovered a profound sense of calm and purpose, and found that life became generally easier. This pivotal experience led to a lasting friendship and creative collaboration with Andrea.</p>
    
    <p>In 2020, during the Covid lockdown, Julia committed to deepening her understanding of hypnotherapy by embarking on a two-year training program and certification under Andrea's guidance. Initially envisioning hypnosis as a tool for her art practice, Julia soon recognized its profound transformative power and felt compelled to integrate it into all aspects of her work.</p>
    
    <p>This passion gave birth to Spectral Center, an innovative practice that combines creativity, imagination, and the transformative potential of the subconscious mind. Julia's offerings include 1:1 hypnotherapy sessions, group sessions, and digital self-hypnosis designed to make the power of hypnosis accessible, beautiful, and enjoyable.</p>
    
    <p>Driven by a deep curiosity about the subconscious and a desire to empower others to heal themselves, Julia also creates immersive experiences through t.r.a.n.c.e community hypnosis sessions with live music with Diana Duta, meditative lecture performances, and personalized sound prescriptions with the Audio Placebo Plaza collective, alongside Erin Gee and Vivian Li. She also co-hosts and produces the <em>A Kind of Harmony Podcast</em>, focused on the transformative potential of sound, with Amanda Harvey.</p>
    
    <p>Julia's work has been showcased internationally at esteemed venues such as the Karachi Biennale (PK), Haus der Kulturen der Welt (DE), Cafe OTO (UK), Q-O2 (BE), Palais des Beaux-Arts de Paris (FR), and Musée d'art de Joliette (QC), among others.</p>
    </Drop>
</Body>
       <Body>
    <SectionToggle onClick={() => toggleSection('hypnosis')}>What is Hypnosis?</SectionToggle>
    <Drop isOpen={openSections.hypnosis}>
    <p>Hypnosis is a focused state, closer to daydreaming than to sleep, where the analyzing, second-guessing part of the mind steps back and the subconscious becomes easier to reach directly. A habit you've tried to talk yourself out of for years, or a fear that never responds to reasoning, becomes workable in that state in a way it isn't in ordinary waking life. Not through willpower. Through direct access.</p>
    <p>What comes up in a session — the images, the language, the specific suggestions — depends entirely on what you're working with. There's no fixed script. The subconscious has its own dialect, and part of the work is learning to listen in it.</p>
    </Drop>
    </Body>
    <Body>
    <SectionToggle onClick={() => toggleSection('services')}>Services</SectionToggle>
<Drop isOpen={openSections.services}>
    <h3>1:1 Hypnotherapy</h3>
    <p>Offered virtually or in person, 1:1 hypnotherapy is the most potent form of hypnosis, as sessions are tailored specifically to your intentions. Each session includes a consultation, and often involves dialogue between you and the therapist while the hypnosis is ongoing. This personalized approach ensures that the therapeutic process aligns closely with your unique needs and goals.</p>

    <h3>Group Hypnosis Sessions</h3>
    <p>Group hypnosis combines the practice of hypnotherapy with the synergy of voice, electronics, and resonant instruments. Unlike 1:1 therapy, group sessions focus on collective healing, addressing broader issues commonly experienced by many, such as self-doubt, low energy, pleasure, stress, and anxiety. These sessions benefit from the power of communal rest and shared experiences, fostering a supportive environment for transformation.</p>

    <h3>Self-Hypnosis</h3>
    <p>Self-hypnosis involves listening to pre-recorded sessions designed to guide you into a state of deep relaxation and heightened suggestibility. These tracks offer visualizations and suggestions tailored to your chosen goals, making it easier to achieve and maintain the desired trance state. Self-hypnosis is a convenient and effective way to access the benefits of hypnotherapy at your own pace and in your own space.</p>
    </Drop>
</Body>
    <Body>
    <SectionToggle onClick={() => toggleSection('qualifications')}>Qualifications</SectionToggle>
<Drop isOpen={openSections.qualifications}>
    <ul>
        <li>Registered Hypnotherapist with the International Hypnotherapy Association</li>
        <li>Hypnotherapy Certification (2 years), OIF Training, 2022</li>
        <li>Certification in Trauma Repair and the Chakras, 2025</li>
        <li>Vipassana Meditation Course, 2025</li>
        <li>Post Masters Fine Arts, ENSPAC Paris-Cergy, 2021</li>
        <li>Graduate Diploma in Communication Studies, Concordia University, 2016</li>
    </ul>
    </Drop>
</Body>
    </Wrapper>
    </DeskWrap>
    <Footer/>
    </>
    );
    
    }



    const Gif = styled.img`
    max-width: 100px;
    position: absolute;
    margin-left: 1rem;
    z-index: 1000;
    top: 1rem;
    right: 1rem;

    @media (min-width: 1000px) {
        max-width: 150px;
        right: 2rem;
    }
    `
const DeskWrap = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden;

    @media (min-width: 1000px) {
        flex-direction: row;
    }
`


const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    min-height: 90vh;
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;

    h1 {
        font-size: 2rem;
        margin-bottom: 2rem;
        color: #333;
    }

    @media (min-width: 1000px) {
        padding: 2rem;
        margin-right: 2rem;
    }
`
const SpectraDef = styled.div`
    font-size: 0.9rem;
    line-height: 1.6;
    margin-bottom: 2rem;
    padding: 1rem;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 0.5rem;
    width:95%;

    h2 {
        font-size: 1.1rem;
        margin: 1rem 0;
        color: #333;
    }

    em {
        font-style: italic;
        color: #666;
    }

    ol {
        margin-left: 1.5rem;
        margin-bottom: 1rem;
    }

    li {
        margin-bottom: 0.5rem;
    }

    strong {
        color: #333;
    }
`


const Body = styled.div`
    font-family: var(--font-body);
    margin-top: 2rem;
    width: 100%;
    max-width: 100%;

    h2 {
        font-size: 1.2rem;
        margin-bottom: 1rem;
        color: #333;
        margin-left: .5rem;
    }

    h3 {
        font-size: 1.1rem;
        margin: 1.5rem 0 1rem;
        color: #333;
    }

    p {
        line-height: 1.6;
        margin-bottom: 1.2rem;
        color: #444;
    }

    ul {
        margin-left: 1.5rem;
        margin-bottom: 1.2rem;
    }

    li {
        line-height: 1.6;
        margin-bottom: 0.5rem;
        color: #444;
    }

    @media (min-width: 1000px) {
        margin-top: 0;
        max-width: 50%;
    }
`

 const Drop = styled.div`
  max-height: ${({ isOpen }) => (isOpen ? 'fit-content' : '0')};
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
  overflow: hidden;
  transition: max-height 0.6s ease, opacity 0.6s ease;
  margin: ${({ isOpen }) => (isOpen ? '1rem 0' : '0')};
  padding: ${({ isOpen }) => (isOpen ? '0 1rem' : '0')};
 `

const SectionToggle = styled.h2`
    font-size: 1.2rem;
    cursor: pointer;
    margin: 1rem 0;
    padding: 0.5rem 0;
    border-bottom: 1px solid #eee;
    transition: all 0.3s ease;

    &:hover {
        color: rgba(255, 119, 200, 0.18);
        padding-left: 0.5rem;
    }
`
   const Img = styled.img`
   max-width: 100%;
   border-radius: 0.5rem;
   margin: 1rem 0;
   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

   @media (min-width: 500px) {
    max-width: 70%;
    margin: 1rem auto;
    display: block;
   }

@media (min-width: 1000px) { 
max-width: 500px;

}


   `
    export default About;